<template>
  <div v-if="courseHeatMapPresenter.isPlotting.value" class="h-full flex justify-center items-center">
    <LoadingPanel />
  </div>
  <VueApexCharts
    v-else-if="courseHeatMapPresenter.hasData.value"
    class="pt-4 mx-4"
    height="90%"
    :options="courseHeatMapPresenter.chartOptions.value"
    :series="courseHeatMapPresenter.heatMapSeries.value"
    type="heatmap"
    @click="courseHeatMapPresenter.clickElement"
  />
  <div v-else class="flex items-center justify-center h-full pb-10 text-base text-gray-900 dark:text-dark-text">
    {{ $t('message.noData') }}
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, watch } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { Course } from '@/domain/entities/problem/course'
import { User } from '@/domain/entities/user/user'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useCourseHeatMapPresenter } from '@/presentation/composables/dashboard/useCourseHeatMapPresenter'
import { useProblemSearchModalStatePresenter } from '@/presentation/composables/problem/useProblemSearchModalStatePresenter'

export default defineComponent({
  components: {
    VueApexCharts,
    LoadingPanel
  },
  props: {
    user: {
      type: Object as () => User,
      required: true
    },
    course: {
      type: Object as () => Course,
      required: true
    },
    programLanguage: {
      type: String as () => ProgramLanguageType | 'All',
      required: true
    }
  },
  setup(props, ctx) {
    const problemSearchModalStatePresenter = useProblemSearchModalStatePresenter()
    const courseHeatMapPresenter = useCourseHeatMapPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const plotHeatMap = async () => {
      await courseHeatMapPresenter.plotHeatMap(
        props.course,
        props.user.id,
        props.programLanguage,
        displayLanguage.value,
        isLightMode()
      )
    }
    plotHeatMap()

    onMounted(() => {})

    watch(
      () => props.programLanguage,
      () => {
        plotHeatMap()
      }
    )

    watch(
      () => props.course.shortName,
      () => {
        plotHeatMap()
      }
    )

    return {
      problemSearchModalStatePresenter,
      courseHeatMapPresenter
    }
  }
})
</script>

<style scoped></style>
